/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import {
  Component,
  ContentChildren,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { RemoteControlService } from 'xsmodules/remote-control/services/remote-control.service';
import { RemoteControlDeviceState, DeviceStateRegistryService } from 'app/modules/remote-control/services/device-state-registry.service';
// import { IErrorHandlerService } from 'src/app/core/services/errorHandlerService';
import {
  DeviceService as NGDeviceService,
  GlobalEventBusService,
} from '@nx-fe/services';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
// import { PromptDialogComponent } from 'src/app/ng-app/shared/components/prompt-dialog/prompt-dialog.component';
import { RcDeviceService } from 'xsmodules/remote-control/services/rc-device-service';
import { XsI18nPipe } from '@nx-fe/pipes';
import { IWorkPanelWindow } from 'xsmodules/remote-control/services/work-panel.service';
import { TextCalculatorService } from 'xsmodules/remote-control/services/text-calculator.service';
import { GlobalEvents } from 'app/core/global-event-constants';
import { WorkPanelManagerService, WorkPanelType } from 'xsmodules/remote-control/services/work-panel-manager.service';
import { TicketPageService } from 'xsmodules/ticket/ticket-page.service';
import { IDeviceAction, RcDeviceStateChangeDetectService, RemoteControlDynamicDeviceState } from 'app/modules/remote-control/services/rc-device-change.service';

@Component({
  selector: 'app-rc-title-bar',
  templateUrl: './rc-title-bar.component.html',
  styleUrls: ['./rc-title-bar.component.scss'],
})
export class RcTitleBarComponent implements OnInit, OnDestroy {
  private minWidthToShowLabelNoRecording = 616;
  private minWidthToShowLabelDuringRecording = 750;
  private iconSizeClass = 'icon-md';
  public isExternallyDisabled = false;
  public isTreePanelOpened = false;

  /** See: IRcTitleBarBindings.deviceState */
  private _deviceState: RemoteControlDeviceState;
  private _observer: ResizeObserver;

  private _dynaimcDeviceState: RemoteControlDynamicDeviceState;
  @Input()
  public set deviceState(state: RemoteControlDeviceState) {
    this._deviceState = state;
    this._dynaimcDeviceState = new RemoteControlDynamicDeviceState();
    this.deviceDetectService.deviceStateChanged(this._deviceState, this._dynaimcDeviceState, this.isStandaloneRC());
  }

  public get deviceState(): RemoteControlDeviceState {
    return this._deviceState;
  }

  public get showPopout(): boolean {
    const deviceId = this.deviceState?.device?.mcDeviceId;
    return !!deviceId && !this.remoteControlService.isVideoStreaming(deviceId);
  }

  public get deviceActionList(): IDeviceAction[] {
    this._dynaimcDeviceState?.deviceActionList?.sort((actionA: IDeviceAction, actionB: IDeviceAction) =>
      actionA.Id.localeCompare(actionB.Id)
    )
    return this._dynaimcDeviceState?.deviceActionList;
  }

  /** See: IRcTitleBarBindings.showControls */
  @Input() public showControls: boolean;

  /** See: IRcTitleBarBindings.standAlone */
  @Input() public standAlone: boolean;

  /** See: IRcTitleBarBindings.workPanelKey */
  @Input() public workPanelKey: string;

  /** See: IRcTitleBarBindings.isLicenceActive */
  @Input() public isLicenceActive: boolean;

  /** See: IRcTitleBarBindings.rcTabTitle */
  @Input() public rcTabTitle: string;

  @Input() snapshotRefreshInProgress: boolean;

  private subscriptions: Subscription[] = [];
  onDestroy$ = new Subject<void>();

  private $window: IWorkPanelWindow = window as any;

  private rcPanelHeaderRef: ElementRef;
  private rcPanelTitleRef: ElementRef;
  private buttonsContainerRef: ElementRef;
  private deviceIconRef: ElementRef;
  private searchIncidentRef: ElementRef;
  private deviceNameRef: ElementRef;
  @ViewChildren('rcHeader') rcPanelHeaders!: QueryList<ElementRef>;
  @ViewChildren('rcPanelTitle') rcPanelTitles!: QueryList<ElementRef>;
  @ViewChildren('buttonsContainer') buttonsContainers!: QueryList<ElementRef>;
  @ViewChildren('deviceIcon') deviceIcons!: QueryList<ElementRef>;
  @ViewChildren('deviceName') deviceNames!: QueryList<ElementRef>;
  @ContentChildren('search-incident') searchIncidents!: QueryList<ElementRef>;

  constructor(
    private workPanelManagerService: WorkPanelManagerService,
    private deviceService: RcDeviceService,
    // @Inject('errorHandlerService') private errorHandlerService: IErrorHandlerService,
    private remoteControlService: RemoteControlService,
    private deviceStateRegistry: DeviceStateRegistryService,
    private globalEventBusService: GlobalEventBusService,
    private dialog: MatDialog,
    private saI18nPipe: XsI18nPipe,
    private ticketPageService: TicketPageService,
    private textCalcService: TextCalculatorService,
    private deviceDetectService: RcDeviceStateChangeDetectService
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.globalEventBusService.register(GlobalEvents.leftWorkPanelOpen, () => {
        this.isTreePanelOpened = true;
      })
    );

    this.subscriptions.push(
      this.globalEventBusService.register(GlobalEvents.leftWorkPanelClose, () => {
        this.isTreePanelOpened = false;
      })
    );

    this.remoteControlService.externalPopoutDisabled$.pipe(takeUntil(this.onDestroy$)).subscribe(isDisabled => {
      this.isExternallyDisabled = isDisabled;
    });
  }

  ngAfterViewInit(): void {
    this.rcPanelHeaderRef = this.rcPanelHeaders.first;
    this.rcPanelTitleRef = this.rcPanelTitles.first;
    this.buttonsContainerRef = this.buttonsContainers.first;
    this.buttonsContainers.changes.subscribe(el => {
      this.buttonsContainerRef = el.first;
      this._dynaimcDeviceState.needsDeviceNameTruncated = null;
    });
    this.deviceIconRef = this.deviceIcons.first;
    this.deviceIcons.changes.subscribe(el => {
      this.deviceIconRef = el.first;
      this._dynaimcDeviceState.needsDeviceNameTruncated = null;
    });
    this.deviceNameRef = this.deviceNames.first;
    this.deviceNames.changes.subscribe(el => {
      this.deviceNameRef = el.first;
      this._dynaimcDeviceState.needsDeviceNameTruncated = null;
      this.unobserveTitleResize();
      this.observeTitleResize();
    });
    this.searchIncidentRef = this.searchIncidents.first;
    this.searchIncidents.changes.subscribe(el => {
      this.searchIncidentRef = el.first;
    });
    this._dynaimcDeviceState.needsDeviceNameTruncated = null;
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();

    for (const sub of this.subscriptions) {
      sub.unsubscribe();
    }

    this.unobserveTitleResize();
  }

  public showActionMenu = () => this._dynaimcDeviceState.deviceActionList.length > 0 && !this.rcHasError();

  public isStandaloneRC = (): boolean => {
    if (this.deviceState) {
      return this.standAlone && !this.deviceState.poppedOut;
    }

    return this.standAlone;
  };

  public isMinimized = (): boolean => {
    if (this.deviceState) {
      return this.deviceState.minimized;
    } else {
      return false;
    }
  };

  public minimizeToggle = () => {
    if (this.deviceState && this.deviceState.device) {
      this.deviceStateRegistry.minimizeToggle(this.deviceState.device);
    }
  };

  public getPopoutToolTip = (): string => {
    if (this.getPopoutIsDisabled()|| this.snapshotRefreshInProgress) {
      return this.saI18nPipe.transform('remoteControlPopout_Disabled_While_Busy');
    } else {
      return '';
    }
  };

  public getPopinToolTip = (): string => {
    if (this.getPopoutIsDisabled()) {
      return this.saI18nPipe.transform('remoteControlPopin_Disabled_While_Busy');
    } else {
      return '';
    }
  };

  public getPopoutIsDisabled = (): boolean =>
    this.isExternallyDisabled ||
    (this.deviceState && this.deviceState.device && !this.deviceStateRegistry.canPopout(this.deviceState.device) || this.isRecording());

  public isPopout = (): boolean => this.workPanelManagerService.isPanelPoppedOut(this.workPanelKey);

  public popout = () => {
    if (!this.getPopoutIsDisabled() && !this.snapshotRefreshInProgress) {
      if (this.workPanelManagerService.isDeviceUsedByPanelType(this.deviceState.device, WorkPanelType.rc)) {
        this.globalEventBusService.broadcast(GlobalEvents.popOutStarted, WorkPanelType.rc);
      } else if (this.workPanelManagerService.isDeviceUsedByPanelType(this.deviceState.device, WorkPanelType.liveSnapshot)) {
        this.globalEventBusService.broadcast(GlobalEvents.popOutStarted, WorkPanelType.liveSnapshot);
      }
    }
  };

  public popin = () => {
    if (!this.getPopoutIsDisabled() && !this.snapshotRefreshInProgress) {
      // Get the parent window of current/popout window
      const parentWindow = this.$window.opener as IWorkPanelWindow;

      if (parentWindow) {
        this.deviceState.popoutWindow = this.$window as IWorkPanelWindow;
        this.remoteControlService.popin(this.deviceState, parentWindow);
      }
    }
  };

  public showPopoutButtonsContainer = (): boolean =>
    this.deviceState && this.deviceState.connected && this.showPopout && this.isPopout();

  public showEmbeddedButtonsContainer = (): boolean =>
    this.deviceState &&
    (this.deviceState.connected || this.deviceState.hasError) &&
    !this.showControls &&
    !this.isPopout();

  public rcHasError = (): boolean => this.deviceState && this.deviceState.hasError;

  public onRemoteControlCloseClick = (): void => {
    if (this.deviceStateRegistry.isDiscardBlocked()) {
      const message = this.deviceStateRegistry.getDiscardBlockedReason();
      if (this.$window.confirm(message)) {
        this.stopRemoteControl();
        this.ticketPageService.stopCurrentRemoteControlActivity();
      }
    } else {
      this.stopRemoteControl();
    }
  };

  public hidePanelTitle = (): boolean => {
    const rcPanelWidth = $('#rc-title-bar')[0].offsetWidth;
    if (this.isPopout()) {
      return this.isRecording() && rcPanelWidth < this.minWidthToShowLabelDuringRecording;
    } else {
      return this.isRecording()
        ? rcPanelWidth < this.minWidthToShowLabelDuringRecording
        : rcPanelWidth < this.minWidthToShowLabelNoRecording;
    }
  };

  public getDeviceName = (): string => {
    if (this.deviceState && this.deviceState.device) {
      return this.deviceState.device.deviceName;
    } else {
      return '';
    }
  };

  public getDeviceFamily = (): string => {
    if (this.deviceState && this.deviceState.device) {
      return this.deviceService.getDeviceFamily(this.deviceState.device.kind, this.deviceState.device.family);
    }
  };

  public getDeviceIconClass = (deviceFamily: string): string => {
    deviceFamily = deviceFamily ?? this.getDeviceFamily();
    return this.deviceService.getDeviceIconClass(deviceFamily, this.iconSizeClass);
  };

  public getDeviceScreenIconClass = (deviceFamily: string): string => {
    deviceFamily = deviceFamily ?? this.getDeviceFamily();
    let deviceScreenIconClass = this.deviceService.getDeviceScreenIconClass(deviceFamily, this.iconSizeClass);

    if (deviceScreenIconClass !== '') {
      deviceScreenIconClass += ' online';
    }
    return deviceScreenIconClass;
  };

  public getDeviceURL = (): string => {
    if (this.deviceState && this.deviceState.device) {
      return this.deviceState.device.deviceDetailsUrl;
    } else {
      return '';
    }
  };

  public hasDeviceURL = (): boolean => this.getDeviceURL() !== '';

  public isRecording = () =>
    this.deviceState && this.deviceState.device && this.deviceStateRegistry.isRecording(this.deviceState.device);

  public canHideTicketSearchFill = (): boolean => !this.standAlone || this.isLicenceActive;

  public stopRemoteControl = () => {
    if (this.deviceState && this.deviceState.device) {
      if (this.remoteControlService.stopRemoteControl(this.deviceState.device)) {
        this.globalEventBusService.broadcast(GlobalEvents.remoteControlCloseInitiated, null);
        this.globalEventBusService.broadcast(GlobalEvents.closeRcWorkPanel, null);
      }
    }
  };

  public executeAction = (content: Function) => {
    // placeholder for future action logic
    content();
  };

  public truncateDeviceName = (): boolean => {
    if (this._dynaimcDeviceState.needsDeviceNameTruncated == null) {
      const offset = 50;
      const rcPanelHeaderWidth = this.rcPanelHeaderRef?.nativeElement.offsetWidth ?? 0;
      const rcActivityTitle = this.rcPanelTitleRef?.nativeElement.offsetWidth ?? 0;
      const actionButtons = this.buttonsContainerRef?.nativeElement.offsetWidth ?? 0;
      const deviceIcon = this.deviceIconRef?.nativeElement.offsetWidth ?? 0;
      const standaloneSearchbar = this.searchIncidentRef?.nativeElement.offsetWidth ?? 0;
      const rcPanelTitleAvilableWidth =
        rcPanelHeaderWidth - (rcActivityTitle + deviceIcon + actionButtons + standaloneSearchbar + offset);
      const deviceNameWidth = this.textCalcService.getTextWidth(
        this.getDeviceName(),
        this.textCalcService.getElementFont(this.deviceNameRef?.nativeElement)
      );
      const deviceNameToPanelRatio = deviceNameWidth / rcPanelTitleAvilableWidth;

      if (this.isRecording()) {
        // We use this method to set the width auto (if false) or a fixed percentage (if true).
        // If the title is long, it will be truncated. If the title is short, the width will be fixed, and the space will be between the title and action buttons (dots button).
        // To avoid this problem with the UI, we need to set the width auto when the title is short.
        if (deviceNameWidth < rcActivityTitle) {
          return false;
        }

        this._dynaimcDeviceState.needsDeviceNameTruncated =
          rcActivityTitle === 0 ? deviceNameToPanelRatio > 0.3 : deviceNameToPanelRatio > 0.21;
      } else {
        this._dynaimcDeviceState.needsDeviceNameTruncated = deviceNameToPanelRatio > 0.7;
      }
    }

    return this._dynaimcDeviceState.needsDeviceNameTruncated;
  };

  private observeTitleResize() {
    this._observer = new ResizeObserver(() => {
      this._dynaimcDeviceState.needsDeviceNameTruncated = null;
    });
    if (this.deviceNameRef?.nativeElement) {
      this._observer.observe(this.deviceNameRef?.nativeElement);
    } else {
      console.warn('Cannot monitor the RC title bar resizing, the element not found');
    }
  }

  private unobserveTitleResize() {
    if (this._observer) {
      if (this.deviceNameRef?.nativeElement) {
        this._observer.unobserve(this.deviceNameRef?.nativeElement);
      }
      this._observer = null;
    }
  }
}
